// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.stage-selector_stage-selector_fsJ9W {
  background-clip: padding-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative; /* For the add backdrop button */
  flex-grow: 1;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background-color: var(--ui-white);
  color: var(--text-primary);
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-color: var(--ui-black-transparent);
  border-width: 1px;
  border-style: solid;
  border-bottom: 0;
  cursor: pointer;
  transition: all 0.25s ease;
}

.stage-selector_stage-selector_fsJ9W.stage-selector_is-selected_Lz2kQ {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-color: var(--looks-secondary);
  box-shadow: 0px 0px 0px 4px var(--looks-transparent);
}

.stage-selector_stage-selector_fsJ9W:hover {
  border-color: var(--looks-secondary);
}

.stage-selector_header_FIlev {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(2.75rem - 2px);
  background-color: var(--ui-white);
  color: var(--text-primary);
  /*
    border-top-left-radius: \$space;
    border-top-right-radius: \$space;
    disable */
  border-bottom: 1px solid var(--ui-black-transparent);
  width: 100%;
  transition: background-color 0.25s ease;
}

.stage-selector_header-title_t9UhC {
  font-size: 0.625rem;
  font-weight: bold;
  color: var(--text-primary);

  /* @todo: make this a mixin for all UI text labels */
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  transition: color 0.25s ease;
}

.stage-selector_stage-selector_fsJ9W.stage-selector_is-selected_Lz2kQ .stage-selector_header_FIlev {
  background-color: var(--looks-secondary);
}

.stage-selector_stage-selector_fsJ9W.stage-selector_is-selected_Lz2kQ .stage-selector_header-title_t9UhC {
  color: #ffffff;
}

.stage-selector_count_FUO9X {
  padding: 0.3rem 0.75rem;
  font-size: 0.625rem;
  color: var(--text-primary);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.stage-selector_label_YEx5s {
  margin: 0.75rem 0 0.25rem;
  font-size: 0.6rem;
  color: var(--text-primary);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  text-align: center;
}

.stage-selector_costume-canvas_cRPnz {
  display: block;
  margin-top: 0.25rem;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  border: 1px solid var(--ui-black-transparent);
  border-radius: 0.25rem;
  box-shadow: inset 0 0 4px var(--shadow);
  max-width: 64px;
  max-height: 48px;
}

.stage-selector_add-button_m4M4a {
  position: absolute;
  bottom: 0.75rem;
}

.stage-selector_raised_CRDyr,
.stage-selector_raised_CRDyr .stage-selector_header_FIlev {
  background-color: var(--drop-highlight);
  transition: all 0.25s ease;
}

.stage-selector_raised_CRDyr:hover {
  transform: scale(1.05);
}

.stage-selector_receivedBlocks_nZtOI {
  animation: stage-selector_glowing_Q6XYo 250ms;
}

@keyframes stage-selector_glowing_Q6XYo {
  10% {
    box-shadow: 0 0 10px #7fff1e;
  }
  90% {
    box-shadow: 0 0 10px #7fff1e;
  }
  100% {
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/stage-selector/stage-selector.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB,EAAE,gCAAgC;EACpD,YAAY;EACZ,2DAA2D;EAC3D,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B;;;aAGW;EACX,oDAAoD;EACpD,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;;EAE1B,oDAAoD;EACpD,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,6CAA6C;EAC7C,sBAAsB;EACtB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAAwB;AAC1B;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.stage-selector {\n  background-clip: padding-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative; /* For the add backdrop button */\n  flex-grow: 1;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  background-color: var(--ui-white);\n  color: var(--text-primary);\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  border-color: var(--ui-black-transparent);\n  border-width: 1px;\n  border-style: solid;\n  border-bottom: 0;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n.stage-selector.is-selected {\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  border-color: var(--looks-secondary);\n  box-shadow: 0px 0px 0px 4px var(--looks-transparent);\n}\n\n.stage-selector:hover {\n  border-color: var(--looks-secondary);\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: calc(2.75rem - 2px);\n  background-color: var(--ui-white);\n  color: var(--text-primary);\n  /*\n    border-top-left-radius: $space;\n    border-top-right-radius: $space;\n    disable */\n  border-bottom: 1px solid var(--ui-black-transparent);\n  width: 100%;\n  transition: background-color 0.25s ease;\n}\n\n.header-title {\n  font-size: 0.625rem;\n  font-weight: bold;\n  color: var(--text-primary);\n\n  /* @todo: make this a mixin for all UI text labels */\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  transition: color 0.25s ease;\n}\n\n.stage-selector.is-selected .header {\n  background-color: var(--looks-secondary);\n}\n\n.stage-selector.is-selected .header-title {\n  color: #ffffff;\n}\n\n.count {\n  padding: 0.3rem 0.75rem;\n  font-size: 0.625rem;\n  color: var(--text-primary);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.label {\n  margin: 0.75rem 0 0.25rem;\n  font-size: 0.6rem;\n  color: var(--text-primary);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  text-align: center;\n}\n\n.costume-canvas {\n  display: block;\n  margin-top: 0.25rem;\n  width: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 0.25rem;\n  box-shadow: inset 0 0 4px var(--shadow);\n  max-width: 64px;\n  max-height: 48px;\n}\n\n.add-button {\n  position: absolute;\n  bottom: 0.75rem;\n}\n\n.raised,\n.raised .header {\n  background-color: var(--drop-highlight);\n  transition: all 0.25s ease;\n}\n\n.raised:hover {\n  transform: scale(1.05);\n}\n\n.receivedBlocks {\n  animation: glowing 250ms;\n}\n\n@keyframes glowing {\n  10% {\n    box-shadow: 0 0 10px #7fff1e;\n  }\n  90% {\n    box-shadow: 0 0 10px #7fff1e;\n  }\n  100% {\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stage-selector": `stage-selector_stage-selector_fsJ9W`,
	"stageSelector": `stage-selector_stage-selector_fsJ9W`,
	"is-selected": `stage-selector_is-selected_Lz2kQ`,
	"isSelected": `stage-selector_is-selected_Lz2kQ`,
	"header": `stage-selector_header_FIlev`,
	"header-title": `stage-selector_header-title_t9UhC`,
	"headerTitle": `stage-selector_header-title_t9UhC`,
	"count": `stage-selector_count_FUO9X`,
	"label": `stage-selector_label_YEx5s`,
	"costume-canvas": `stage-selector_costume-canvas_cRPnz`,
	"costumeCanvas": `stage-selector_costume-canvas_cRPnz`,
	"add-button": `stage-selector_add-button_m4M4a`,
	"addButton": `stage-selector_add-button_m4M4a`,
	"raised": `stage-selector_raised_CRDyr`,
	"receivedBlocks": `stage-selector_receivedBlocks_nZtOI`,
	"glowing": `stage-selector_glowing_Q6XYo`
};
export default ___CSS_LOADER_EXPORT___;
